export * from './checkbox';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/checkbox/index.js
// module id = ../../../material/checkbox/index.js
// module chunks = 3